import { isColumnVisibleByDefault } from '../../../utils/partialPermissionUtils';

const statusCol = (gantt, t) => {
  const name = 'status';
  const isVisible = isColumnVisibleByDefault(name);

  const statusValues = [
    {
      icon: 'fas fa-clock',
      color: 'yellow',
      value: 'Advancement',
      label: t('exportable.Avancement', 'Avance'),
      weigth: 4,
    },
    {
      icon: 'fas fa-clock',
      color: 'yellow',
      value: 'Overdue',
      label: t('exportable.Overdue', 'Vencido'),
      weigth: 3,
    },
    {
      icon: 'fas fa-clock',
      color: 'yellow',
      value: 'Doing',
      label: t('exportable.Doing', 'En Curso'),
      weigth: 2,
    },
    {
      icon: 'far fa-check-circle',
      color: 'green',
      value: 'Done',
      label: t('exportable.Done', 'Hecho'),
      weigth: 1,
    },
    {
      icon: 'fas fa-minus-circle',
      color: 'grey',
      value: 'Waiting',
      label: t('exportable.Waiting', 'Esperando'),
      weigth: 0,
    },
  ];

  return {
    name,
    label: t('gantt.columns.status', 'Estado'),
    width: '*',
    resize: true,
    hide: !isVisible,
    align: 'center',
    template: (activity) => {
      const isOdd = gantt.oddColsConfig?.status || false;
      let iconHtml = '';
      let title = '';

      switch (activity.status) {
        case 'Advancement':
          title = t('exportable.Advancement', 'Adelantado');
          iconHtml = '<img style="width: 17px; height: 17px" src="https://criticapp.s3.sa-east-1.amazonaws.com/ontime-new.png" />';
          break;
        case 'Overdue':
          title = t('exportable.Overdue', 'Vencido');
          iconHtml = '<img style="width: 17px; height: 17px" src="https://criticapp.s3.sa-east-1.amazonaws.com/overdue-new.png" />';
          break;
        case 'Waiting':
          title = t('exportable.Waiting', 'Esperando');
          iconHtml = '-';
          break;
        case 'Doing':
          title = t('exportable.Doing', 'En Curso');
          iconHtml = '<img style="width: 17px; height: 17px" src="https://criticapp.s3.sa-east-1.amazonaws.com/doing-new.png" />';
          break;
        case 'Done':
          title = t('exportable.Done', 'Hecho');
          iconHtml = '<img style="width: 17px; height: 17px" src="https://criticapp.s3.sa-east-1.amazonaws.com/done-new.png" />';
          break;
        default:
          return `<div class="${isOdd ? 'odd-col' : 'non-odd-col'}"> </div>`;
      }
      return `<div class="${isOdd ? 'odd-col' : 'non-odd-col'}" title="${title}"><span>${iconHtml}</span></div>`;
    },
    data_type: 'array/icon',
    mixed: false,
    mixed_from: ['Overdue', 'Advancement'],
    from_values: statusValues,
    groupable: false,
    groupable_switch: ['1 → N', 'N → 1'],
    orderable: true,
    orderable_switch: ['1 → N', 'N → 1'],
    filterable: true,
  };
};

export default statusCol; 